import AppRoute from "models/AppRoute"

const MonthlyClosingRoute = new AppRoute({
    route: "/monthly-closing",
    navbar: true,
    authRequired: true,
})

export default MonthlyClosingRoute
